<template>
  <div class="buy">
    <app-header />
    <div class="container">
      <div class="d-inline mr-4">
        <button type="button" v-b-modal.company class="btn btn-primary">
          Crear empresa
        </button>
      </div>
      <div class="d-inline">
        <button type="button" v-on:click="generateCVS()" class="btn btn-primary">
          CSV
        </button>
      </div>
      <div class="float-right">
        <button type="button" v-b-modal.modalFilters class="btn btn-primary">
          Filtros
        </button>
      </div>
      <div class="">
      </div>
      <div class="table table-padded">
        <table>
          <thead>
            <tr>
              <th>{{$t('table.id')}}</th>
              <th>{{$t('table.company')}}</th>
              <th>{{$t('table.value')}}</th>
              <th>{{$t('table.nit')}}</th>
              <th>{{$t('table.codPug')}}</th>
              <th>{{$t('table.url')}}</th>
              <th>{{$t('table.action')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(company,index) in companies" :key="index">
              <td>{{company.id}}</td>
              <td>{{company.name}}</td>
              <td>${{money(company.balance)}}</td>
              <td>{{(company.nit)}}</td>
              <td>{{(company.codPuc)}}</td>
              <td>{{company.confirmUrl}}</td>
              <td>
                <button class="actionBtnTable nobtn" v-b-modal.company v-on:click="edit(company)">
                  <i class="material-icons" style="color: #dab51b;">edit</i>
                </button>
                <button class="actionBtnTable nobtn" v-b-modal.infoBanks>
                  <i class="material-icons" v-on:click="edit(company)" style="color: #dab51b;">account_balance</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <app-pagination :data="companies" />
      </div>
      <b-modal id="modalFilters" ref="modalFilters" centered class='box-modal' title="Filtrar Empresa" hide-footer>
        <div class="box-modal">
          <form v-on:submit.prevent="read">
            <div class="form-group">
              <label class='control-label'>Código Empresa </label>
              <input type="text" class="form-control" v-model='filters.codeCompany'>
            </div>
            <div class="form-group">
              <label class='control-label'>Nombre Empresa </label>
              <input type="text" class="form-control" v-model='filters.name'>
            </div>
            <div class="d-inline mr-4">
              <button type="submit" v-on:click="clearFilter()" class="btn btn-primary">Limpiar
              </button>
            </div>
            <div class="d-inline">
              <button type="submit" class="btn btn-primary">Filtrar</button>
            </div>
          </form>
        </div>
      </b-modal>
      <b-modal id="company" ref="company" title="Crear empresa" @ok="create()">
        <form>
          <div class="form-group">
            <label>Nombre</label>
            <input type="text" class="form-control" v-model="company.name">
          </div>
          <div class="form-group">
            <label>Nit</label>
            <input type="text" class="form-control" v-model="company.nit">
          </div>
          <template>
            <div class="form-group">
              <label>Código</label>
              <input type="text" class="form-control" v-model="company.code">
            </div>
          </template>
          <div class="form-group">
            <label>CodPuc</label>
            <input type="text" class="form-control" v-model="company.codPuc">
          </div>
          <div class="form-group">
            <label>Url</label>
            <input type="text" class="form-control" v-model="company.url">
          </div>
        </form>
      </b-modal>
      <b-modal id="infoBanks" ref="infoBanks" title="Bancos" size="lg" hide-footer>
        <div class="table table-padded">
          <b-card mb-2>
            <b-table :items="bankUsers" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" @filtered="onFiltered" class="table table-padded">
              <template slot="id" slot-scope="row">
                {{row.item.id}}
              </template>
              <template slot="name" slot-scope="row">
                {{row.item.Bank.name}}
              </template>
              <template slot="cost" slot-scope="row">
                {{row.item.cost}}
              </template>
              <template slot="type" slot-scope="row">
                <template v-if="row.item.typeCost == 'fixed'">
                  Fijo
                </template>
                <template v-else>
                  Porcentaje
                </template>
              </template>
              <template slot="min" slot-scope="row">
                {{row.item.min}}
              </template>
              <template slot="value" slot-scope="row">
                {{row.item.value}}
              </template>
              <template slot="action" slot-scope="row">
                <button class="actionBtnTable nobtn" v-b-modal.editBankUser v-on:click="editBank(row.item)">
                  <i class="material-icons" style="color: #dab51b;">edit</i>
                </button>
              </template>
            </b-table>
          </b-card>
        </div>
      </b-modal>
      <b-modal  id="editBankUser" ref="editBankUser" title="Editar costos" centered @ok="updateBank">
        <div class="">
          <form >
            <div class="form-group">
              <label>Tipo de Costo</label>
              <select class="form-control" v-model="userBank.typeCost">
                <option value="fixed">Fijo</option>
                <option value="percent">Porcentaje</option>
              </select>
            </div>
            <div class="form-group">
              <label>Costo bancario</label>
              <money class="form-control" v-model="userBank.cost"></money>
            </div>
            <div class="form-group">
              <label>Valor mínimo sin multa</label>
              <money class="form-control" v-model="userBank.min"></money>
            </div>
            <div class="form-group">
              <label>Multa</label>
              <money class="form-control" v-model="userBank.value"></money>
            </div>

          </form>
        </div>
      </b-modal>
    </div>
    <app-footer />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  FETCH_COMPANIES,
  CREATE_COMPANY,
  FETCH_BANKS,
  FETCH_BANKUSERS,
  UPDATE_BANKUSERS
} from "@/store/actions.type";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppPagination from "@/components/AppPagination.vue";

export default {
  components: {
    AppHeader,
    AppFooter,
    AppPagination
  },
  data: function() {
    return {
      current: "",

      filters: {
        codeCompany: ""
      },

      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 30, 40, 50],
      filter: null,

      company: {
        name: "",
        nit: "",
        code: "",
        url: "",
        codPuc: ""
      },
      costs: {},
      userBank: {},

      data: {},
      processForm: {
        observation: ""
      },
      fields: [
        { key: "id", label: "Id", sorteable: true },
        { key: "name", label: "Nombre", sorteable: true },
        { key: "type", label: "Tipo", sorteable: true },
        { key: "cost", label: "Costo", sorteable: true },
        { key: "min", label: "Mínimo", sorteable: true },
        { key: "value", label: "Multa", sorteable: true },
        { key: "action", label: "Acción", sorteable: true }
      ]
    };
  },

  methods: {
    read() {
      this.$refs.modalFilters.hide();
      this.$refs.editBankUser.hide();
      this.$store.dispatch(FETCH_COMPANIES, this.filters);
    },

    clearFilter() {
      this.filters = {};
      this.read();
    },

    create() {
      this.$store
        .dispatch(CREATE_COMPANY, this.company)
        .then(result => {
          this.company = {};
          this.$snotify.success(result.message);
          this.read();
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    },

    updateBank() {
      this.userBank.bankId = this.userBank.Bank.id;
      this.userBank.companyId = this.userBank.company.id;
      console.log(this.userBank);
      this.$store
        .dispatch(UPDATE_BANKUSERS, this.userBank)
        .then(result => {
          this.$snotify.success(result.message);
          this.read();
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    },

    edit(company) {
      this.company = company;
      this.$store.dispatch(FETCH_BANKUSERS, this.company);
    },

    editBank(userBank) {
      this.userBank = userBank;
      this.userBank.company = this.company;
    },

    generateCVS() {
      const rows = this.companies.map(item => {
        return ["#" + item.code, item.name, "$" + item.balance];
      });

      let csvContent = "";
      rows.forEach(function(rowArray) {
        rowArray = rowArray.map(c => `"${c}"`);
        let row = rowArray.join(";");
        csvContent += row + "\r\n";
      });
      var hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURI(csvContent);
      hiddenElement.target = "_blank";
      hiddenElement.download = "Empresas.csv";
      hiddenElement.click();
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  },

  computed: {
    ...mapGetters(["companies", "banks", "bankUsers"])
  },

  mounted() {
    this.$store.dispatch(FETCH_BANKS);
    this.read();
  }
};
</script>
    <style lang="scss">
.buy {
  input {
  }

  label {
    color: #7b7b7b;
    font-weight: 900;
    font-size: 18px;
  }

  select {
    -webkit-appearance: none;
  }

  .box-modal {
    h5 {
      color: #dab51b !important;
      font-weight: 900;
      font-size: 25px;
    }
  }

  .box-filters {
    padding: 20px;
    width: 359px;
    border-radius: 20px;
    box-shadow: 1px 4px 7px rgba(0, 0, 0, 0.38);
    float: right;

    button {
      width: 100%;
    }
  }
}
</style>
